import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, X } from "lucide-react";

/** h-12 action button + p-4 top/bottom, plus the iOS home-indicator inset. */
const BAR_HEIGHT = "calc(5rem + env(safe-area-inset-bottom, 0px))";

export function StickyMobileCTA() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const rafId = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (rafId.current) return;
      rafId.current = requestAnimationFrame(() => {
        const heroHeight = window.innerHeight * 0.8;
        const shouldShow = window.scrollY > heroHeight && !isDismissed;
        setIsVisible(shouldShow);
        rafId.current = 0;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsDismissed(true);
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible || isDismissed) return null;

  return (
    <>
      {/* The bar is `fixed`, so it sits outside flow and would cover whatever
          is at the bottom of the page -- including a keyboard-focused footer
          link, which fails WCAG 2.4.11 (Focus Not Obscured). This spacer adds
          the equivalent scroll room at the end of the document so the last
          content can always scroll clear of the bar. Height mirrors BAR_HEIGHT
          below (h-12 button + p-4 top/bottom) plus the safe-area inset. */}
      <div aria-hidden="true" className="sm:hidden" style={{ height: BAR_HEIGHT }} />

      <div className={`fixed bottom-0 left-0 right-0 z-50 sm:hidden ${isClosing ? 'animate-slide-out-bottom' : 'animate-slide-in-bottom'}`}>
      <div className="bg-primary/95 backdrop-blur-sm border-t border-secondary/20 p-4 shadow-lg" style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom, 0px))" }}>

        <div className="flex items-center gap-3">
          <Button
            className="flex-1 bg-accent hover:bg-accent/90 text-accent-foreground font-semibold h-12"
            onClick={() => navigate("/auth?tab=signup")}
          >
            Get Started
            <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
          </Button>
          <Button aria-label="Dismiss"
            variant="ghost"
            size="icon"
            className="text-secondary/60 hover:text-secondary hover:bg-secondary/10 h-12 w-12"
            onClick={handleDismiss}
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </Button>
        </div>
      </div>
      </div>
    </>
  );
}